/** @typedef {import('./Customer.svc')} Types */

export class Customer {
	constructor($http, API) {
		'ngInject';
		this.http = $http;
		this.gate = '/customer';
		this.API = API;
	}

	/** @param {Types.GetCustomerDetailsParams} params */
	getCustomerDetails(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/customerDetail`, {params, cache});
	}

	/** @param {Types.GetCustomerLocationDetailsParams} params */
	getCustomerLocationDetails(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/customerLocationDetail`, {params, cache});
	}

	/** @param {Types.GetCurrentSystemDetailsParams} params */
	getCurrentSystemDetails(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/currentSystemDetails`, {params, cache});
	}

	/** @param {Types.CreateCustomerParams} params */
	createCustomer(params) {
		return this.http.post(`${this.API}${this.gate}/createCustomer`, params);
	}

	/** @param {Types.UpdateCustomerParams} params */
	updateCustomer(params) {
		return this.http.post(`${this.API}/v2${this.gate}/updateCustomer`, params);
	}

	/** @param {Types.CreateCustomerLocationParams} params */
	createCustomerLocation(params) {
		return this.http.post(`${this.API}${this.gate}/createCustomerLocation`, params);
	}

	/** @param {Types.UpdateCustomerLocationParams} params */
	updateCustomerLocation(params) {
		return this.http.post(`${this.API}/v2${this.gate}/updateCustomerLocation`, params);
	}

	/** @param {Types.SaveCurrentSystemPreferencesParams} params */
	saveCurrentSystemPreferences(params) {
		return this.http.post(`${this.API}/v2${this.gate}/saveCurrentSystemPreferences`, params);
	}
}
//
let compMod = angular.module('mod.svc.CustomerService', []).service('CustomerService', Customer);
export default (compMod = compMod.name);
